import React from 'react';
import AppLogo from '../components/AppLogo';
import UserInfo from '../components/UserInfo';
import { StyledAppHeader } from '../Default/index.styled';
import SystemSwitcher from '../components/SystemSwitcher';

const SuperAdminHeader: React.FC = () => {
  return (
    <StyledAppHeader>
      <AppLogo />
      <div style={{ flex: 1 }} />
      <SystemSwitcher />
      <UserInfo />
    </StyledAppHeader>
  );
};

export default SuperAdminHeader;
